import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import {
  ConnectionChangeType,
  InterpretingSessionType,
} from 'features/call/call-base/enums';
import { sendConnectionCallState } from 'features/call/call-base/store';
import { sendAnalyticsInfo } from 'features/analytics/helpers';
import {
  callIdSelector,
  selectActualCallOwnerUserId,
} from 'features/call/call-base/store/selectors';
import { handleError } from 'features/notification/store';
import { ReturnToQueueDaoService } from 'features/return-to-queue/services';
import type { ReturnToQueuePayload } from 'features/return-to-queue/store';

export const returnToQueue = createAsyncThunk(
  'returnToQueue',
  async (
    payload: ReturnToQueuePayload,
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const state = getState() as RootState;
      const callId = callIdSelector(state);
      const userId = selectActualCallOwnerUserId(state);

      const { holdServerIp } = await ReturnToQueueDaoService.returnToQueue({
        callId,
        userId,
        ...payload,
      });

      dispatch(
        sendConnectionCallState({
          connectionChangeType: ConnectionChangeType.RETURN_TO_QUEUE_DISCONNECT,
          interpretingSessionType: InterpretingSessionType.NORMAL,
        })
      );

      dispatch(
        sendAnalyticsInfo({
          Method: 'returnToQueue',
          Message: 'Call returned to queue successfully',
          Event: 'CallReturnedToQueue',
        })
      );

      return holdServerIp;
    } catch (error) {
      dispatch(handleError({ error }));
      return rejectWithValue(error);
    }
  }
);
